var map = {
	"./components/BoxesComponent.vue": 988,
	"./components/Collaboration.vue": 9590,
	"./components/Contact.vue": 122,
	"./components/ContactForm.vue": 7556,
	"./components/DotsComponent.vue": 7197,
	"./components/DotsComponent2.vue": 1902,
	"./components/InstaFeedComponent.vue": 2205,
	"./components/MoreProjectsComponent.vue": 1920,
	"./components/ProjectEditComponent.vue": 7227,
	"./components/ProjectsComponent.vue": 6904,
	"./components/ProjectsDisplayComponent.vue": 2374,
	"./components/SingleProjectComponent.vue": 2674,
	"./components/WelcomeComponent.vue": 9955,
	"./components/foot.vue": 4469,
	"./components/navbar.vue": 8223
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5642;